import { useTranslation } from "react-i18next";

import style from "./Bankinfo.module.scss";
import { Row, Col, Form, Input, Button, Select } from "antd";
import { convertPersian, delay, formatDigit, regexFormater, validateInput } from "../../../../tools/tools";
import ReactInputMask from "react-input-mask";
import SteperNewProfile from "../modules/steper";
import EmptyData from "../../../../components/empty/EmptyData";
import { useAPIPublic } from "../../../../tools/api";
import { useDispatch, useSelector } from "react-redux";
import { simcardPurchase } from "../../../../reducer/serviceReducer";
import { useNavigate } from "react-router-dom";
import { _adr } from "../../../../address";
import { useEffect, useState } from "react";
import Loading from "../../../../components/loader/loading";
import Layouts, { useLayouts } from "../../../layout/layouts";
import { CheckToken } from "../../../../tools/services";
const BankInfo = () => {
	const { updateUserBankAcountInfo } = useAPIPublic();
	const [t] = useTranslation("global");
	const [frmBankInfo] = Form.useForm();
	const nav = useNavigate();
	const dispatch = useDispatch();
	const formData = useSelector((state) => state?.from?.newUser);
	const [valCardNumber, setValCardNumber] = useState("");

	const { _currentUser } = useSelector((state) => {
		return state?.another;
	});

	const [loading, setLoading] = useState(false);

	const { refreshUser, checkLoginUser } = useLayouts();

	//check Login
	const [isLogin, setLogin] = useState();

	//user Info
	const [user, setUser] = useState({});

	useEffect(() => {
		const checkLogin = async () => {
			const isCheck = await checkLoginUser();
			if (isCheck) {
				const userInfo = await refreshUser();
				setUser(userInfo || {});
				if (formData?.hasCompleted && !formData?.hasCompleted) {
					setLogin(false);
				} else {
					setLogin(isCheck);
				}
			}
		};
		checkLogin();
	}, [checkLoginUser, refreshUser]);

	useEffect(() => {
		frmBankInfo.setFieldValue("cardnumber", valCardNumber);
	}, [valCardNumber]);
	useEffect(() => {
		if (formData?.profile) {
			frmBankInfo.setFieldsValue({
				bankname: formData?.profile?.bankname,
				bankaccountnumber: formData?.profile?.bankaccountnumber,
				cardnumber: formData?.profile?.cardnumber,
				shebanumber: formData?.profile?.shebanumber,
			});
			setValCardNumber(formData?.profile?.cardnumber);
		}
	}, [formData]);

	const handleSubmit = async (values) => {
		try {
			setLoading(true);
			let payload = {
				bankname: values.bankname,
				bankaccountnumber: values.bankaccountnumber,
				cardnumber: regexFormater(values.cardnumber).removeCharacter("-"),
				shebanumber: "IR" + values.shebanumber,
			};

			const response = await updateUserBankAcountInfo(payload);
			await delay(3000);
			const qUser = await refreshUser(true);
			if (response) {
				if (!isLogin) {
					dispatch(
						simcardPurchase({
							newUser: {
								profile: {
									...formData?.profile,
									...values,
								},
								hasCompleted: false,
							},
						}),
					);
				}

				nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Review);
			}
			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	};
	return (
		<>
			<SteperNewProfile current={2} />
			<div className={style.BankInfo}>
				<div className="page_title">
					<h3>اطلاعات بانکی</h3>
					<p>لطفا اطلاعات حساب بانکی خود را با دقت وارد کنید.</p>
				</div>
				<Form form={frmBankInfo} id="frmBankInfo" onFinish={handleSubmit} layout="vertical">
					<Row gutter={30}>
						<Col xxl={8} xl={10} lg={10} md={12} sm={12} xs={24}>
							<Form.Item name="bankname" label="نام بانک" rules={[validateInput({ t: t, validate: true, type: "persian" })]}>
								{/* <Select notFoundContent={<EmptyData />}>
                    {initialData?.gender.map((item, key) => (
                      <Select.Option key={key} value={item.value}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select> */}
								<Input autoComplete="off" maxLength={32} />
							</Form.Item>
						</Col>
						<Col xxl={8} xl={10} lg={10} md={12} sm={12} xs={24}>
							<Form.Item name="bankaccountnumber" label="شماره حساب بانکی" rules={[validateInput({ t: t, validate: true, type: "number" })]}>
								<Input autoComplete="off" maxLength={32} inputMode="numeric" dir="ltr" />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={30}>
						<Col xxl={8} xl={10} lg={10} md={12} sm={12} xs={24}>
							<Form.Item name="cardnumber" label="شماره کارت" rules={[validateInput({ t: t, validate: true, type: "cardno" })]}>
								<div>
									<ReactInputMask
										mask="9999-9999-9999-9999"
										// onInput={(e) => {

										// }}
										value={frmBankInfo.getFieldValue("cardnumber")?.length > 0 ? frmBankInfo.getFieldValue("cardnumber") : ""}
										onChange={(e) => {
											e.target.value = convertPersian(e.target.value);
											setValCardNumber(e.target.value);
										}}
										dir="ltr"
										autoComplete="off"
									/>
								</div>
							</Form.Item>
						</Col>
						<Col xxl={8} xl={10} lg={10} md={12} sm={12} xs={24}>
							<Form.Item name="shebanumber" label="شماره شبا" rules={[validateInput({ t: t, validate: true, length: 24 })]}>
								<Input addonAfter="IR" autoComplete="off" dir="ltr" maxLength={24} />
							</Form.Item>
						</Col>
					</Row>
				</Form>
				{isLogin ? (
					<>
						<div className={`holder-button ${style.bankAction}`}>
							<Button form="frmBankInfo" key={frmBankInfo} htmlType="submit" className="btn-aptel">
								ویرایش
							</Button>
							<Button onClick={() => nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Review)}>
								انصراف
							</Button>
						</div>
					</>
				) : (
					<div className={`holder-button ${style.bankAction}`}>
						<Button form="frmBankInfo" key={frmBankInfo} htmlType="submit" className="btn-normal btn-aptel">
							مرحله بعد
						</Button>
						<Button
							onClick={() => nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Address)}
							className="btn-normal">
							بازگشت
						</Button>
					</div>
				)}
			</div>

			<Loading isOpen={loading} />
		</>
	);
};

export default BankInfo;
